import common from "./common.json";
import creditEffect from "./creditEffect.json";

const ID = { common, creditEffect };
export default ID;
